import { Routes } from '@angular/router';
import { OnboardingFormComponent } from './components/onboarding-form/onboarding-form.component';
import { ThankYouPageComponent } from './components/thank-you-page/thank-you-page.component';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';

export const routes: Routes = [
  { path: 'onboarding', component: OnboardingFormComponent },
  { path: 'thank-you', component: ThankYouPageComponent },
  { path: '404', component: NotFoundPageComponent },
  { path: '**', redirectTo: '404', pathMatch: 'full' },
];
